import script from "./commentItem.vue?vue&type=script&setup=true&lang=js"
export * from "./commentItem.vue?vue&type=script&setup=true&lang=js"

import "./commentItem.vue?vue&type=style&index=0&id=b0a6bf6a&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0a6bf6a"]])

export default __exports__